/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail, FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailFromJSONTyped, FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailToJSON, } from './FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail';
export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirement.js.map